<template>
  <div class="admin-dashboard">
    <aside class="admin-sidebar">
      <div class="sidebar-header">
        <div class="logo-section" @click="goToDomains">
          <img alt="Segofy logo" src="../../assets/logo.png" class="logo">
        </div>
        <div class="admin-badge">Admin Panel</div>
      </div>
      
      <nav class="admin-nav">
        <div class="nav-item" :class="{ active: isActive('/admin/users') }" @click="goToUsers">
          <svg class="nav-icon" viewBox="0 0 20 20" fill="currentColor">
            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
          </svg>
          <span class="nav-text">Users</span>
        </div>
        <div class="nav-item" :class="{ active: isActive('/admin/sites') }" @click="goToSites">
          <svg class="nav-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clip-rule="evenodd" />
          </svg>
          <span class="nav-text">Sites</span>
        </div>
        <div class="nav-item" :class="{ active: isActive('/admin/subscription-plans') }" @click="goToPlans">
          <svg class="nav-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
          </svg>
          <span class="nav-text">Subscription Plans</span>
        </div>
        <div class="nav-item" :class="{ active: isActive('/admin/payments') }" @click="goToPayments">
          <svg class="nav-icon" viewBox="0 0 20 20" fill="currentColor">
            <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clip-rule="evenodd" />
          </svg>
          <span class="nav-text">Payments</span>
        </div>
        <div class="nav-item" :class="{ active: isActive('/admin/ai-review') }" @click="goToAIReview">
          <svg class="nav-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M9 4.5a.75.75 0 01.721.544l.813 2.846a3.75 3.75 0 002.576 2.576l2.846.813a.75.75 0 010 1.442l-2.846.813a3.75 3.75 0 00-2.576 2.576l-.813 2.846a.75.75 0 01-1.442 0l-.813-2.846a3.75 3.75 0 00-2.576-2.576l-2.846-.813a.75.75 0 010-1.442l2.846-.813a3.75 3.75 0 002.576-2.576l.813-2.846A.75.75 0 019 4.5z" clip-rule="evenodd" />
          </svg>
          <span class="nav-text">AI Review</span>
        </div>
      </nav>
      
      <div class="sidebar-footer">
        <div class="nav-item exit-admin" @click="goToDomains">
          <svg class="nav-icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clip-rule="evenodd" />
          </svg>
          <span class="nav-text">Exit Admin</span>
        </div>
        <span class="version">API v{{ version }}</span>
      </div>
    </aside>
    
    <main class="admin-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'
import { ref, onMounted } from 'vue'
import { api } from '../../utils/api'

export default {
  name: 'AdminDashboardView',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const version = ref('')

    const fetchVersion = async () => {
      try {
        const data = await api('/version')
        version.value = data.version
      } catch (error) {
        console.error('Failed to fetch API version:', error)
        version.value = 'unknown'
      }
    }

    const goToDomains = () => {
      router.push('/domains')
    }

    const goToSites = () => {
      router.push('/admin/sites')
    }

    const goToUsers = () => {
      router.push('/admin/users')
    }

    const goToPlans = () => {
      router.push('/admin/subscription-plans')
    }

    const goToPayments = () => {
      router.push('/admin/payments')
    }

    const goToAIReview = () => {
      router.push('/admin/ai-review')
    }

    const isActive = (path) => {
      return route.path === path || route.path.startsWith(path + '/')
    }

    onMounted(() => {
      fetchVersion()
    })

    return {
      version,
      goToDomains,
      goToSites,
      goToUsers,
      goToPlans,
      goToPayments,
      goToAIReview,
      isActive
    }
  }
}
</script>

<style scoped>
.admin-dashboard {
  display: flex;
  min-height: 100vh;
  background-color: var(--bg-primary);
}

.admin-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 100vh;
  background-color: var(--bg-secondary);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-section {
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
}

.logo {
  height: 40px;
  transition: transform 0.2s;
}

.logo:hover {
  transform: scale(1.05);
}

.admin-badge {
  background: linear-gradient(135deg, var(--accent-color) 0%, #8b5cf6 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.admin-nav {
  flex: 1;
  padding: 20px 0;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.2s;
  color: rgba(255, 255, 255, 0.7);
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.nav-item.active {
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  border-right: 3px solid var(--accent-color);
}

.nav-icon {
  margin-right: 12px;
  width: 20px;
  height: 20px;
}

.nav-text {
  font-weight: 500;
  font-size: 15px;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.exit-admin {
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.6);
}

.exit-admin:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.version {
  display: block;
  text-align: center;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
}

.admin-content {
  margin-left: 240px;
  flex: 1;
  padding: 30px;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .admin-sidebar {
    width: 200px;
  }

  .admin-content {
    margin-left: 200px;
    padding: 20px;
  }

  .admin-badge {
    font-size: 12px;
    padding: 6px 12px;
  }
}
</style>
